export default {
    orderInvoiceList: state => state.invoiceList,
}
